import React, { useMemo } from "react";

import { useIsMutating } from "@tanstack/react-query";

import { userKeys } from "../api/queryKeys";
import { BeRightBack } from "../domains/BeRightBack";
import { useAuth } from "../hooks/auth";
import Loading from "../utils/Loading";

import { LoggedInRoutes } from "./loggedIn";
import { PublicRoutes } from "./public";

export const AppRoutes = () => {
  const user = useAuth();
  const isLoggingIn = useIsMutating({ mutationKey: userKeys.all });

  const isLoggedIn = useMemo(
    () => user.isSuccess && user.data.user && !user.data.user["redirect"],
    [user.isSuccess, user.data]
  );

  if (isLoggingIn || user.isLoading) {
    return <Loading centered={true} />;
  }

  if (isLoggedIn) {
    // if (!user.data?.user.email.includes("intelligems.io"))
    //   return <BeRightBack />;
    return <LoggedInRoutes />;
  }

  return <PublicRoutes />;
};
